exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3ffcbe5e] h1{font-size:48px;font-family:SFPro;line-height:1.1;font-weight:700;color:#000}[data-v-3ffcbe5e] h2,h3[data-v-3ffcbe5e],h4[data-v-3ffcbe5e]{font-family:SFProBold}[data-v-3ffcbe5e] h2{font-size:28px}[data-v-3ffcbe5e] h3{font-size:20px}[data-v-3ffcbe5e] h4{font-size:16px}.centered[data-v-3ffcbe5e]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ffcbe5e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/egarant-companies/EgarantCompaniesList.vue
// module id = ONEd
// module chunks = 0